module.exports = __webpack_public_path__ + "img/2023102703.e78f40bb.webp";